import React from 'react';

import {
    Button
} from 'reactstrap';

import Isvg from 'react-inlinesvg';
import mitIdIcon from '../assets/svg/mitid.svg';
import { API_ENDPOINT } from '../constants'
function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
/**
* MitIDIdentity 
* @author   Stefan Pantic
*/
class MitIDIdentity extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            changeQrCode: true
        }
    }

    componentDidMount() {
        let mitIdDataAfterRedirect = {}
        let roomId = window.location.href.split('roomId=')[1]
        // if there is more state then just link add them in mitIDPage.js
        mitIdDataAfterRedirect.redirectLink = '/video-call/' + this.props.conversation._id + '?roomId=' + roomId
        mitIdDataAfterRedirect.conversationId = this.props.conversation?._id
        fetch(API_ENDPOINT + `/users/mitID/web/start`, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({ group: this.props.group, conversation: this.props.conversation._id, redirectLink: '/video-call/' + this.props.conversation._id + '?roomId=' + roomId, mitIdDataAfterRedirect: JSON.stringify(mitIdDataAfterRedirect), alias: this.props.alias ? this.props.alias : localStorage.getItem('groupAlias') })
        }).then(res => res.json()).then((result) => {
            if (result.redirect_url) {
                this.setState({
                    showMitId: result.redirect_url,
                }, () => {
                    // this.props.handleMitIdStarted(this.state.showMitId)
                })
            }
        })
    }

    componentDidUpdate(prevState) {
        // if (this.state.mitIDRedirect && prevState.mitIDRedirect !== this.state.mitIDRedirect && this.state.mitIdKey) {
        //     if (this.state.mitIDRedirect.includes('sessionStatus=Finished')) {
        //         this.props.handleMitIdIdentity(this.state.mitIdKey)
        //         this.setState({
        //             mitIdKey: null,
        //         })
        //     } else {
        //         this.setState({
        //             showMitId: false,
        //             mitIDRedirect: null,
        //             error: 'Something went wrong, please try again'.translate(this.props.lang)
        //         }, () => {
        //             this.props.handleMitIdStarted(null)
        //         })
        //     }
        // } else if (!this.state.showMitId && prevState.showMitId !== this.state.showMitId && !this.state.mitIDRedirect && this.state.mitIdKey) {
        //     this.props.handleMitIdIdentity(this.state.mitIdKey)
        //     this.setState({
        //         mitIdKey: null,
        //     })
        // }
    }

    render() {
        return (
            <div className="mit-id-identity">

                <a disabled={this.props.disabled} href={this.state.showMitId}><Isvg src={mitIdIcon} />{'Log in with MitID'.translate(this.props.lang)}</a>



                {/* {
                    this.state.showMitId ?
                        <div className='bank-id-checkout'>
                            <iframe ref={(node) => this.bankIdIframe = node} onLoad={() => {
                                try {
                                    if (this.bankIdIframe && this.bankIdIframe.contentWindow && this.bankIdIframe.contentWindow.location && this.bankIdIframe.contentWindow.location.href && this.bankIdIframe.contentWindow.location.href.indexOf('sessionId') !== -1) {
                                        this.setState({
                                            mitIDRedirect: this.bankIdIframe.contentWindow.location.href

                                        })
                                    } else {
                                        this.setState({
                                            showMitId: false,
                                        }, () => {
                                            this.props.handleMitIdStarted(null)
                                        })
                                    }
                                } catch (e) { }
                            }} src={this.state.showMitId} style={this.state.mitIDRedirect ? { opacity: 0 } : { width: '100%', height: 660, border: 'none' }} />
                        </div>
                        :
                        null
                } */}

            </div>
        )
    }

}

export default MitIDIdentity;